'use client';
import { useEffect } from 'react';
import useFooterStore from '@/store/footer';
import { usePathname } from 'next/navigation';

export default function CustomFooter({children}: {children: React.ReactNode}) {
    const showFullFooter = useFooterStore((store) => store.showFullFooter);
    const pathname = usePathname();
    useEffect(() => {
        const images = document.querySelectorAll('.custom-footer img');
        images.forEach((image) => {
            image.setAttribute('loading', 'lazy');
        });
    }, []);
    
    return (
        <>
        {
            pathname != '/feedback' ? (
                <div className={`custom-footer ${showFullFooter ? 'h-full' : 'h-[75vh] md:h-full'} `}>
                    {children}
                </div>
            ) : <></>
        }
        </>
    );
}